// lib/shout-constants.ts
// Plain constants shared between the server route and client components.
// Split out from lib/shout.ts (which imports prisma) so client components
// can import just the constants without bundling the Prisma client.

export const SHOUT_MAX_LENGTH = 200;
